import { Insight, Interview, Tag } from '../types';

export const mockTags: Tag[] = [
  { id: '1', name: '顧客ニーズ', color: '#2196F3' },
  { id: '2', name: '競合分析', color: '#4CAF50' },
  { id: '3', name: '価格戦略', color: '#FF9800' },
  { id: '4', name: '営業手法', color: '#9C27B0' },
  { id: '5', name: '市場動向', color: '#F44336' },
  { id: '6', name: '製品改善', color: '#00BCD4' },
  { id: '7', name: 'ターゲティング', color: '#795548' },
  { id: '8', name: 'コミュニケーション', color: '#607D8B' }
];

export const mockInterviews: Interview[] = [
  {
    id: 'int-001',
    date: '2024-01-15',
    interviewer: '田中 雄介',
    interviewee: '佐藤 恵美（A社営業部長）',
    transcript: `
【インタビュー開始】

田中：本日はお忙しい中、お時間をいただきありがとうございます。まず、現在の営業活動における主な課題についてお聞かせください。

佐藤：こちらこそ、ありがとうございます。現在一番の課題は、顧客の意思決定プロセスが複雑化していることですね。以前は部長クラスの判断で決まっていたことが、今は複数の部署を巻き込んだ稟議プロセスになっていて、営業サイクルが長期化しています。

田中：具体的にはどのくらい長期化しているのでしょうか？

佐藤：以前は平均3ヶ月程度だった営業サイクルが、今は6ヶ月から1年近くかかることも珍しくありません。特にIT関連の案件では、セキュリティチェックやコンプライアンス確認に時間がかかっています。

田中：そのような状況に対して、どのような対策を取られていますか？

佐藤：まず、初期段階で関係者を洗い出すことを重視しています。キーパーソンを早期に特定し、各部署の懸念事項を個別にヒアリングするようにしています。また、競合他社の動向も含めた市場分析資料を準備して、経営層への提案時に使用しています。

田中：価格競争についてはいかがでしょうか？

佐藤：価格だけでの勝負は避けるように心がけています。むしろ、顧客の課題解決にフォーカスした提案を行い、ROIを明確に示すことで価値訴求をしています。価格が高くても、それに見合う価値があることを数値で示せれば、顧客は納得してくれます。

田中：営業チーム内での情報共有はどのように行っていますか？

佐藤：週次の営業会議で案件の進捗共有をしていますが、成功事例や失敗事例の横展開が不十分だと感じています。特に若手営業メンバーがベテランのノウハウを学ぶ機会が限られているのが課題ですね。

【インタビュー終了】
    `,
    summary: 'A社営業部長へのインタビュー。営業サイクルの長期化、関係者の複雑化、価格競争への対応策について議論。'
  },
  {
    id: 'int-002',
    date: '2024-01-22',
    interviewer: '山田 美香',
    interviewee: '鈴木 翔太（B社営業担当）',
    transcript: `
【インタビュー開始】

山田：本日はよろしくお願いします。まず、顧客開拓において最も効果的だと感じている手法についてお教えください。

鈴木：よろしくお願いします。私の経験では、既存顧客からの紹介が最も成功率が高いです。満足度の高い顧客からの紹介案件は、初回から信頼関係が構築されているため、成約率が約7割と非常に高くなっています。

山田：紹介を獲得するために、何か特別な取り組みをされていますか？

鈴木：定期的な顧客満足度調査を実施し、問題があれば即座に対応するようにしています。また、契約後も継続的にフォローアップを行い、新しい課題がないかヒアリングしています。顧客との関係を単なる取引関係ではなく、パートナーシップと捉えています。

山田：新規開拓の際の課題はありますか？

鈴木：最大の課題は、最初のアポイントメントを取ることですね。メールや電話での営業は反応率が低く、効率が悪いです。最近は、LinkedInなどのSNSを活用したアプローチや、業界イベントでの直接的なネットワーキングに力を入れています。

山田：顧客のニーズをどのように把握していますか？

鈴木：ヒアリングでは必ず「現在困っていること」「理想的な状態」「そのギャップを埋めるために何が必要か」の3点を聞くようにしています。また、業界のトレンドや法規制の変化についても情報収集し、顧客が気づいていない潜在的なニーズを提示することもあります。

山田：提案書作成で心がけていることはありますか？

鈴木：顧客の言葉をそのまま使うことを重視しています。ヒアリング内容を元に、顧客が使った表現や価値観を提案書に反映させることで、「この人は自分たちのことを理解してくれている」という印象を与えられます。

【インタビュー終了】
    `,
    summary: 'B社営業担当へのインタビュー。顧客開拓手法、紹介営業の活用、新規開拓の課題、ニーズ把握の手法について議論。'
  },
  {
    id: 'int-003',
    date: '2024-02-05',
    interviewer: '松本 健太郎',
    interviewee: '高橋 由美子（C社マネージャー）',
    transcript: `
【インタビュー開始】

松本：本日はお時間をいただき、ありがとうございます。最近の営業環境の変化についてどのように感じていらっしゃいますか？

高橋：ありがとうございます。最も大きな変化は、顧客の情報収集力が格段に向上していることです。営業担当者が訪問する前に、すでにWebサイトや口コミサイトで詳細な情報を調べている顧客が多くなっています。

松本：それによって営業スタイルに変化はありましたか？

高橋：大きく変わりました。以前のように製品スペックを一から説明するのではなく、顧客が既に知っている情報を前提として、より深い課題解決の提案に時間を使うようになりました。コンサルティング的な要素が強くなっていますね。

松本：競合との差別化はどのように図っていますか？

高橋：製品機能での差別化は難しくなっているので、サポート体制やアフターサービスでの差別化に注力しています。特に導入後の運用支援や、定期的な改善提案を行うことで、長期的な関係構築を重視しています。

松本：営業チームの育成について、何か工夫されていることはありますか？

高橋：ロールプレイングを重視しています。様々なタイプの顧客を想定したシナリオを作成し、週1回は実践的な練習を行っています。また、成功事例だけでなく、失敗事例も積極的に共有し、同じ過ちを繰り返さないようにしています。

松本：デジタルツールの活用はいかがですか？

高橋：CRMシステムとSFAツールを導入していますが、まだ十分に活用できていないのが実情です。データの入力に時間がかかり、営業活動の時間が削られるという声も聞こえています。今後はより使いやすいツールの導入を検討しています。

【インタビュー終了】
    `,
    summary: 'C社マネージャーへのインタビュー。営業環境の変化、顧客の情報収集力向上、差別化戦略、チーム育成について議論。'
  }
];

export const mockInsights: Insight[] = [
  {
    id: 'ins-001',
    title: '日常的な関わりを大切にしよう！',
    content: `## 概要

計画的ではなく自然な日常の交流を通じて、信頼関係を深める。

## 効果

形式ばらない日常の交流が親近感を生み、持続可能な人間関係を構築する。

## 事例

「本社に〇〇さんがいたら『お疲れ様です』と声をかけたり、夜遅く残っている同僚とお菓子を食べたり、雑なコミュニケーションを意識的に重ねることで自然な関係を築いた。」

## 取り組みの具体例

- 日常の挨拶を積極的に行う
- 小さな気遣いを行動に移す（お菓子をシェアするなど）`,
    summary: '自然な日常交流を通じて信頼関係を深め、持続可能な人間関係を構築する',
    tags: [mockTags[7]], // コミュニケーション
    interviewId: 'int-001',
    createdAt: '2024-01-16',
    updatedAt: '2024-01-16'
  },
  {
    id: 'ins-002',
    title: '「相手に興味がある」姿勢を示そう！',
    content: `## 概要

相手への純粋な関心を自然な態度や表情で伝え、心地よい存在であることを意識する。

## 効果

相手が自分に関心を持たれていると感じることで、心理的な距離が縮まり、深い信頼関係が構築される。

## 事例

「会話中、自然と『あなたに興味があります』という態度や表情を示すことで、信頼が深まり対話が円滑になった。」

## 取り組みの具体例

- 積極的に相手の話を聞く姿勢を示す
- 興味のあることを表情や態度に自然に表す`,
    summary: '相手への純粋な関心を態度や表情で伝え、心理的距離を縮めて信頼関係を構築する',
    tags: [mockTags[7]], // コミュニケーション
    interviewId: 'int-001',
    createdAt: '2024-01-16',
    updatedAt: '2024-01-16'
  },
  {
    id: 'ins-003',
    title: '組織の力を活用しよう！',
    content: `## 概要

自分一人で課題を解決しようとせず、組織内のリソースを積極的に活用する姿勢を示す。

## 効果

チームや他部門の協力を得ることで解決能力が向上し、業務の成果が上がりやすくなる。

## 事例

「積極的に他のサイトや部門に相談・協力依頼を行い、結果的に問題解決の質とスピードを向上させた。」

## 取り組みの具体例

- 課題が発生したら周囲や他部署に積極的に相談する
- 自分の限界を認識し、積極的に助けを求める`,
    summary: '組織内リソースを積極活用し、チームや他部門の協力で解決能力と成果を向上させる',
    tags: [mockTags[3], mockTags[7]], // 営業手法、コミュニケーション
    interviewId: 'int-002',
    createdAt: '2024-01-23',
    updatedAt: '2024-01-23'
  },
  {
    id: 'ins-004',
    title: '部署を超えた共通体験を作ろう！',
    content: `## 概要

部門を超えたプロジェクトやイベントに積極的に参加し、共通体験を作ることで自然な交流のきっかけを生む。

## 効果

共通の体験を共有することで、自然と部門間の壁が低くなり、円滑なコミュニケーションが可能になる。

## 事例

「25周年式典の運営に参加し、部門を超えたチーム活動を通じて仲間意識や信頼を深めた。」

## 取り組みの具体例

- 社内のイベントやプロジェクトに積極的に関与する
- 同年代や共通の背景を持つ人とのつながりを意識する`,
    summary: '部門を超えたプロジェクトやイベント参加で共通体験を作り、部門間の壁を低くする',
    tags: [mockTags[7], mockTags[3]], // コミュニケーション、営業手法
    interviewId: 'int-002',
    createdAt: '2024-01-23',
    updatedAt: '2024-01-23'
  },
  {
    id: 'ins-005',
    title: '顧客や同僚に「できること」を常に伝えよう！',
    content: `## 概要

日常会話の中で自分や自部署が提供可能なサービスや能力を自然に伝える。

## 効果

事前に自社の能力を伝えておくことで、必要なタイミングで具体的な相談や依頼が発生しやすくなる。

## 事例

「顧客との何気ない会話で総務業務として『周年イベントの会場探しができます』と伝えたところ、『実はイベント専門チームがある』という新たな相談を引き出した。」

## 取り組みの具体例

- 会話の中で軽く、自社ができることを伝える
- 無理強いせず情報共有として自然に提供する`,
    summary: '日常会話で自社の能力を自然に伝え、必要時に相談や依頼が発生しやすい環境を作る',
    tags: [mockTags[0], mockTags[7], mockTags[3]], // 顧客ニーズ、コミュニケーション、営業手法
    interviewId: 'int-003',
    createdAt: '2024-02-06',
    updatedAt: '2024-02-06'
  }
];
